module.exports = __webpack_public_path__ + "static/media/doctor.0e4d14a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Update/doctor.png
// module id = 656
// module chunks = 0